export default "__VITE_ASSET__D7rg3Y0W__"